import parseParams from 'bz-utilities/modules/connect-params-parser';
import type SearchStore from 'connect/web/src/stores/search-store';
import { SearchType } from 'connect/web/src/stores/search-store';
import { computed } from 'mobx';
import { inject, observer } from 'mobx-react';
import * as React from 'react';
import type { OnlineSection } from 'tm3-core/api.dtos';
import { OnlineSectionTypes } from 'tm3-core/api.dtos';
import Offer from '../../../offer';
import Explore from '../../controls/explore';
import Header from '../../controls/header';
import Packages from '../../controls/packages';
import Search from '../../controls/search';
import Services from '../../controls/services';

export interface IProps {
  mode: string;
  searchStore?: SearchStore;
}

const sectionTypeMap = {
  [OnlineSectionTypes.Header]: Header,
  [OnlineSectionTypes.Search]: Search,
  [OnlineSectionTypes.AppointmentSearch]: Search,
  [OnlineSectionTypes.ClassSearch]: Search,
  [OnlineSectionTypes.Categories]: Explore,
  [OnlineSectionTypes.Offers]: Offer,
  [OnlineSectionTypes.Services]: Services,
  [OnlineSectionTypes.Packages]: Packages
};

@inject('searchStore')
@observer
class Sections extends React.Component<IProps> {
  @computed
  get orderedList(): OnlineSection[] {
    const { mode, searchStore } = this.props;
    const { sections } = searchStore!;

    return parseParams(sections.filter((x) => x.mode === mode)).sort(
      (a, b) => +a.sortIndex - +b.sortIndex
    );
  }

  render() {
    const { orderedList } = this;

    return orderedList.map((section, i) => {
      let Component = sectionTypeMap[section.type];
      return <Component key={section.id} {...section.params} />;
    });
  }
}

export default Sections;
